import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import i18n from "./i18n";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import { Provider } from "react-redux";
import store from "./store/store";
import { ToastContainer } from "react-toastify";
import { FirebaseProvider } from "./firebase/firebase";
import { SocketProvider } from "./Socket/socketProvider";

ReactDOM.render(
  <Suspense fallback={<div>Loading translations...</div>}>
    <BrowserRouter>
      <SocketProvider>
        <FirebaseProvider>
          <Provider store={store}>
            <ToastContainer />
            <App />
            <ScrollToTop />
          </Provider>
        </FirebaseProvider>
      </SocketProvider>
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
